export enum Environment {
  Production = 'production',
  QA = 'qa',
  Dev = 'development',
}
